import { ConfigProvider, Divider, Skeleton, Image, Row, Col, Button, message, Typography, Card, Input } from 'antd';
import React, { useEffect, useState, useContext } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, HeartOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import Label_language from '../language';
// import InfiniteScroll from './components/InfiniteScroll';
import InfiniteScroll from 'react-infinite-scroll-component';
import WYSIWYGModal from './components/WYSIWYGModal';
import TitleModal from './components/TitleModal';
import Carousel_news_ticker from './components/Carousel_news_ticker';
import VideoModal from './components/VideoModal';
import VideoWatchModal from './components/VideoWatchModal';
const { Title, Paragraph, Text, Link } = Typography;
const label_language = Label_language.cramschool.children
const VideoWatch = () => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [title, setTitle] = useState(label_language.Common.children.add[language]);
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [title_modal, set_tiltle_modal] = useState(false);
    const [open_wyswyg, set_open_wyswyg] = useState(false);
    const [videoShow, setVideoShow] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [titleEditcard, setTitleEditCard] = useState({});
    const [editcard, setEditCard] = useState({});
    const [datas, setDatas] = useState([])
    const [page, setpage] = useState(1);
    const [total, setTotal] = useState(1);
    const [content, setContent] = useState('');
    const [itemdatacheck, setitemdatacheck] = useState(true);
    const [messageApi, contextHolder] = message.useMessage();
    const [permission, setPermission] = useState(false);
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const handleOnEdit = (value) => {
        setTitle('修改影片');
        setColor('f09a45');
        setEdit(true);
        setEditCard(value);
        setOpen(true)
    }
    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/video', { params: { "blog_type_id": 19, cur_page: page, size: 9 } })
            .then((response) => {
                if (page == 1) {
                    setDatas(response.data.data);
                    setTotal(response.data.total)
                    get_picture(response.data.data);
                } else {
                    setDatas(pre => { return ([...pre, ...response.data.data]) });
                    setTotal(response.data.total)
                    get_picture([...datas, ...response.data.data]);
                }

            })
            .finally(() => {
                setitemdatacheck(false)
            })
    }
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/header/video', { params: { "blog_type_id": 20 } })
            .then((response) => {
                setContent(response.data.data[0]);
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const get_title = () => {
        axios
            .get('/cramSchool/api/blog/type', { params: { 'blog_type_id': 20 } })
            .then((response) => {
                let color_tmp = response.data.data[0].background_color.split(',');
                // console.log(color_tmp);
                setTitleEditCard(
                    (pre) => {
                        return (
                            {
                                ...pre,
                                background_color1: color_tmp[0],
                                background_color2: color_tmp[1],
                                color_show: response.data.data[0].color_show,
                            }
                        )
                    }
                )
                if (response.data.data[0].file_id.length != 0) {
                    let data_tmp = [];
                    response.data.data[0].file_id.map((tmp, i) => {
                        axios
                            .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                            .then((response) => {
                                var blob_ = new Blob([response.data], {
                                    type: "image/jpg",// this is the only MIME for SVG

                                });
                                const dataurl = URL.createObjectURL(blob_);
                                data_tmp.push({ uid: tmp, url: dataurl })
                                setTitleEditCard((pre) => {
                                    if (tmp.file_url != undefined) {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [...tmp.file_id, tmp],
                                                file_url: [...tmp.file_url, dataurl]
                                            }
                                        )
                                    } else {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [tmp],
                                                file_url: [dataurl]
                                            }
                                        )
                                    }
                                })
                            })
                    })
                    setTitleEditCard((pre) => {
                        return (
                            {
                                ...pre,
                                file_show: response.data.data[0].file_show,
                                // file_id: data_tmp.map((item) => item.uid),
                                // file_url: data_tmp.map((item) => item.url)
                            }
                        )
                    })
                }
            })
    }
    useEffect(() => {
        get_header();
        get_title();
        get_data();
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                if (response.data.length != 0) {
                    setPermission(true);
                }
            })
    }, [])
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    const handleEdit = () => {
        setOpen(false);
        axios
            .patch(`/cramSchool/api/blog/video`, [{ ...editcard, "blog_type_id": 19 }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                    get_data();
                }
            })
        // console.log(editcard);
    }
    const handleSubmit = () => {
        console.log(editcard)
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            axios
                .post(`/cramSchool/api/blog/video`, [{ ...editcard, "blog_type_id": 2 }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.add_error[language],
                        });
                        get_data();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.add_success[language],
                        });
                        get_data();
                    }
                })
        }
        // console.log(editcard);
    }
    const handleDelete = (id) => {
        const deleterow = [{ "blog_id": id }];
        axios
            .delete('/cramSchool/api/blog/video', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.delete_error[language],
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.delete_success[language],
                    });
                    get_data();
                }
            })

    }
    useEffect(() => {
        datas.forEach(each_item => {
            if (each_item.blog_id === editcard.blog_id) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [datas])
    const [sortModalOpen, setSortModalOpen] = useState(false)
    const handleTitleUpdate = (file_id) => {
        // console.log({ ...titleEditcard, background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`, file_id: file_id });
        axios
            .patch('/cramSchool/api/blog/type', [{
                ...titleEditcard,
                background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`,
                file_id: file_id,
                blog_type_id: 20
            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_title();
            })
    }
    const handleUpdate = () => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/video`, [{
                // "title": 'teacher_blog_header',
                // "content": content,
                ...content,
                "blog_type_id": 20,
                "annoucement_time": time,
                // "blog_id": 105

            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_header();
                set_open_wyswyg(false);
            })
    }
    useEffect(() => {
        // console.log(page)
        get_data();
    }, [page])
    const ChangePage = () => {
        if (itemdatacheck) {
            return;
        }
        // setLoading(true);
        setitemdatacheck(false);
        setpage(pre => pre + 1)
    }
    return (
        <>
            {contextHolder}
            <VideoModal
                open={open}
                title={title}
                edit={edit}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                handleDelete={handleDelete}
            />
            <WYSIWYGModal
                open={open_wyswyg}
                setOpen={set_open_wyswyg}
                data={content?.content}
                setData={setContent}
                handleUpdate={handleUpdate}
            />
            <VideoWatchModal
                open={videoShow}
                setOpen={setVideoShow}
                editcard={editcard}
            />
            <TitleModal
                open={title_modal}
                setOpen={set_tiltle_modal}
                title={'修改'}
                color={'f09a45'}
                edit={true}
                name={'影片分享區'}
                editcard={titleEditcard}
                setEditCard={setTitleEditCard}
                handleEdit={handleTitleUpdate}
                fileShow={true}
            />
            <Row gutter={[8, 24]} justify={'end'}>
                {permission ? <>
                    <Col >
                        <Button className='example' style={{ backgroundColor: '#f09a45', color: '#FFFFFF' }} onClick={e => set_tiltle_modal(true)}>編輯標題</Button>
                    </Col>
                </> : null}
                {titleEditcard?.color_show == 1 ? <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${titleEditcard.background_color1}, #ffffff,${titleEditcard.background_color2})`, padding: '10px', position: 'relative' }}>
                        <Col style={{ textAlign: 'center' }}>
                            <span style={{ fontSize: '3rem' }}>影片分享區</span>
                        </Col>
                        {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                        </Col> */}
                    </Row>
                </Col> : null}
                {titleEditcard?.file_show == 1 ? <Col span={24}>
                    <Carousel_news_ticker
                        logo
                        height={'100%'}
                        file_url={titleEditcard?.file_url != undefined && titleEditcard?.file_url.length != 0 && titleEditcard?.file_url.map(map_item => map_item)}
                    />
                </Col> : null}
                <Col span={24}>
                    <Row gutter={[40, 16]} justify="center" align="middle" style={{ padding: '10px' }}>
                        <Col md={{ span: 6 }} sm={{ span: 24 }}>
                            <Row gutter={[8, 8]}>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                            </Row>
                        </Col>
                        <Col md={{ span: 8 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                            <Row justify={'center'}>
                                <Col >
                                    <span dangerouslySetInnerHTML={{ __html: content?.content }}></span>
                                </Col>
                            </Row>
                            {permission ? <>
                                <Col className='example' style={{ position: 'absolute', left: '90%', top: '0%' }}>
                                    <EditOutlined
                                        className='example'
                                        style={{
                                            backgroundColor: '#F9D4E5',
                                            fontSize: '1.2rem',
                                            borderRadius: '50%',
                                            padding: '8px'
                                        }}
                                        onClick={e => set_open_wyswyg(true)}
                                    />
                                </Col>
                            </> : null}
                        </Col>
                        <Col md={{ span: 6 }} sm={{ span: 24 }}>
                            <Row gutter={[8, 8]}>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                {/* <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: 'linear-gradient(to right, #cf4da6, #ddb5b4)', padding: '10px', position: 'relative' }}>
                        <Col>
                            <Col style={{ textAlign: 'center' }}>
                                <span style={{ fontSize: '3.5rem', color: '#FFFFFF' }}>{label_language.home.children.environment[language]}</span>
                            </Col>
                        </Col >
                    </Row>
                </Col> */}
                {permission ? <>
                    <Col span={24}>
                        <Row gutter={[8, 8]} justify={'end'} style={{
                            textAlign: 'center', paddingTop: '20px', paddingBottom: '20px'
                        }}>
                            <Col className='example'>
                                <Button style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle('新增影片'); setColor('d65b77'); setEditCard({}); setEdit(false); setOpen(true) }} icon={<PlusOutlined />}>新增影片</Button >
                            </Col>
                            {/* <Col>
                                <Button
                                    onClick={() => setSortModalOpen(true)}
                                >修改貼文排序
                                </Button>
                                <EnvironmentSortModal
                                    data={datas}
                                    open={sortModalOpen}
                                    edit={true}
                                    title={"修改排序"}
                                    color={"f09a45"}
                                    editcard={editcard}
                                    setOpen={setSortModalOpen}
                                    get_data={get_data}
                                />
                            </Col> */}
                        </Row>
                    </Col>

                </> : null}
                <Col span={24}>
                    {/* <Row gutter={[8, 16]}>
                        <BlogCard edit={permission} span={8} data={datas} type={'environment'} page={'Environment'} handleOnEdit={handleOnEdit} />
                    </Row> */}
                    {/* <InfiniteScroll
                        data={
                           
                        }
                        page={page}
                        total={total}
                        size={9}
                        setpage={e => setpage(e)}
                        loading={itemdatacheck}
                        method="window" /> */}
                    <InfiniteScroll
                        dataLength={datas?.length}
                        next={ChangePage}
                        hasMore={datas?.length < total}
                        loader={
                            <Skeleton
                                paragraph={{
                                    rows: 1,
                                }}
                                active
                            />
                        }
                        endMessage={<Divider plain>已經沒有貼文囉</Divider>}
                        scrollableTarget="scrollableDiv"
                    >
                        <Row gutter={[16, 16]} style={{ padding: '10px' }}>
                            {datas && datas.map((value, index) => {
                                return (
                                    <>
                                        < Col sm={{ span: 24 }
                                        } md={{ span: 8 }} justify='center' >
                                            <Card
                                            // style={{ minHeight: "17rem", position: 'relative', alignItems: 'center' }}
                                            // style={{ backgroundColor: value.background_color || '#ffffff' }}
                                            >
                                                <Row gutter={[24, 16]} justify={'center'} style={{ minHeight: "18rem", position: 'relative', alignItems: 'center' }}>
                                                    <Col span={20}>
                                                        {permission ? <>
                                                            <Row style={{ position: 'relative', justifyContent: 'end', }}>
                                                                <Col className='example' style={{ position: 'absolute', left: '100%', top: '0%', zIndex: 99 }}>
                                                                    <EditOutlined
                                                                        className='example'
                                                                        style={{
                                                                            backgroundColor: '#F9D4E5',
                                                                            fontSize: '1.2rem',
                                                                            borderRadius: '50%',
                                                                            padding: '8px'
                                                                        }}
                                                                        onClick={e => handleOnEdit(value)}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </>
                                                            : null}
                                                    </Col>
                                                    <Col span={22} style={{ cursor: 'pointer' }} onClick={e => { setEditCard(value); setVideoShow(true) }}>
                                                        <img src={value.youtube_thumbnail} height={'auto'} width={'100%'}></img>
                                                    </Col>
                                                    <Col span={24} >
                                                        < Row gutter={[8, 8]} style={{ textAlign: 'center' }}>
                                                            <Col span={24}>
                                                                <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{value['title']}</span>
                                                            </Col>
                                                            {dimensions['width'] > 500 &&
                                                                (<Col span={24}>
                                                                    <Paragraph
                                                                        ellipsis={{
                                                                            rows: 1,
                                                                            expandable: true,
                                                                            symbol: 'more',
                                                                        }}
                                                                    >
                                                                        {value?.['content'] && (<>
                                                                            {(String(value?.['content']) || '').split('\n').map(map_item => (<>
                                                                                {map_item}<br />
                                                                            </>))}
                                                                        </>)}
                                                                    </Paragraph>
                                                                </Col>)}
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col >
                                    </>
                                )
                            })}
                        </Row>
                    </InfiniteScroll>
                </Col >
            </Row >
        </>
    )
}
export default VideoWatch;